// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"be47a3db","61":"6f651941","105":"e971d1c6","127":"c4292f12","183":"46d75238","189":"b05defbb","308":"feab5b33","516":"b94eff02","563":"226a9f90","728":"94378ac3","732":"8ac1e76c","787":"47f189ac"}[chunkId] + ".chunk.js";
};